import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { THEME_COLORS, images } from '../../../themes';
import Text from '../../CustomTextComponent';


const TableHeader = (props) => {

  const { headerGroups, onClickSort } = props;
  const getSortByToggleProps = (props, { instance, column }) => {
    const { isMultiSortEvent = e => e.shiftKey } = instance;

    return [
      props,
      {
        onClick: column.canSort
          ? e => {
            if (!column.isSorted) {
              onClickSort(column.selector, "asc");
            } else {
              column.isSortedDesc ? onClickSort(column.selector, null) :
                onClickSort(column.selector, "desc")
            }
            e.persist()
            column.toggleSortBy(
              undefined,
              !instance.disableMultiSort && isMultiSortEvent(e)
            );
          }
          : undefined,
        style: {
          cursor: column.canSort ? 'pointer' : undefined,
        },
        title: column.canSort ? 'Toggle SortBy' : undefined,
      },
    ]
  }
  return (
    <div className="header">
      {headerGroups.map((headerGroup) => (
        <div {...headerGroup.getHeaderGroupProps()} className="tr">
          {headerGroup.headers.map((column) => {
            return <>
              <div {...column.getHeaderProps(getSortByToggleProps)} className="th">
                <View style={{ flexDirection: "row" }}>
                  <Text type_of_six={"three_six"}>{column.render('Header')}</Text>
                  {!column.disableSortBy ? <span>{column.isSorted
                    ? column.isSortedDesc
                      ? <Image source={images.sortDownIcon} style={{ height: 15, width: 15, marginTop: 5 }} />
                      : <Image source={images.sortUpIcon} style={{ height: 15, width: 15, marginTop: 5 }} />
                    : <Image source={images.sortIcon} style={{ height: 15, width: 15, marginTop: 5 }} />}</span> : null}
                </View>
              </div>
              <div style={{position:"relative"}}>
                <div
                  {...column.getResizerProps()}
                  className={`resizer ${column.isResizing ? 'isResizing' : ''
                    }`}
                />
              </div>
            </>
          })}
        </div>
      ))}
    </div>
  )
}

export const styles = StyleSheet.create({
  rowHeaderColumn: {
    flex: 1,
    paddingLeft: 10,
    paddingVertical: 8,
    paddingRight: 2,
  },
});


export default TableHeader;
